import { types } from "mobx-state-tree";
import { IInput } from "../../utils/common-interface";
import customtypes from "../../utils/mobx-types-helper";

export const ActualResultAgreementItemModel = types
  .model("ActualResultAgreementItemModel", {
    agreementId: customtypes.optional(types.number, 0),
    description: customtypes.optional(types.string, ""),
    gftrRefCode: customtypes.optional(types.string, "")
  });
export type IActualResultAgreementItemModel = typeof ActualResultAgreementItemModel.Type;

export const ActualResultAgreementListModel = types
  .model("ActualResultAgreementListModel", {
    isSelected: customtypes.optional(types.boolean, false),
    planExistId: customtypes.optional(types.number, 0),
    agreements: customtypes.optional(
      types.array(ActualResultAgreementItemModel),
      []
    )
  })
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    }
  }));
export type IActualResultAgreementListModel =
  typeof ActualResultAgreementListModel.Type;
